/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Clear_TierInputs */



/**
* | output |
* | --- |
* | "Clear the tier filter" |
*
* @param {Partner_Billing_Board_Clear_TierInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_clear_tier = /** @type {((inputs?: Partner_Billing_Board_Clear_TierInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Clear_TierInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stufen-Filter zurücksetzen")
	return /** @type {LocalizedString} */ ("Clear the tier filter")
});